<template>
  <v-container id="delivery-reception-page">
    <!--배송 접수-->
    <div class="page-title">{{$route.name}}</div>

    <c-card title="회원 조회 및 정보 입력" class="mt-12">
      <template #headItems>
        <c-btn outlined color="green" @click="input.registerCustomerDialog = true" tabindex="4">신규회원등록</c-btn>
      </template>

      <v-row align="center" justify="center">
        <v-col cols="8" class="text-center">
          <v-menu style="display: inline-block"
            v-model="input.showCustomerList"
            :close-on-content-click="true"
            offset-y
            nudge-top="30"
          >
            <template v-slot:activator="{ on }">
              <v-text-field class="d-inline-block mx-2" label="회원 이름" v-model="input.name" @keyup.enter="reqSearchCustomer" tabindex="1"></v-text-field>
              <v-text-field class="d-inline-block mx-2" label="전화번호 뒷자리" v-model="input.lastNumber" @keyup.enter="reqSearchCustomer" maxlength="4" tabindex="2"></v-text-field>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in input.customerSearchList"
                :key="index"
                @click="onSelectCustomer(item)"
              >
                <v-list-item-title>{{ item.name }}  {{item.mobileNo}}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <c-btn outlined color="blue" @click="reqSearchCustomer" class="d-inline-block mx-2" tabindex="3">회원조회</c-btn>
        </v-col>
      </v-row>
    </c-card>

    <customer-c-u-dialog :open.sync="input.registerCustomerDialog" :customerFormData="input.customerFormInfo" @reqAddCustomer="reqAddCustomer">
    </customer-c-u-dialog>

    <c-card title="예약자 정보" class="mt-5">
      <c-table :headers="headers" :items="input.items" hide-default-footer>
        <template #name="{item}">
          <span>{{item.name}}</span>
        </template>
        <template #mobileNo="{item}">
          <span>{{item.mobileNo}}</span>
        </template>
        <template #customerType="{item}">
          {{showCustomerType}}
        </template>
        <template #etc="{item}">
          {{getEtcInfo(item)}}
        </template>
        <template #detail="{item}">
          <c-btn icon iconName="search" @click="showCustomerInfoDlg(item)"></c-btn>
        </template>
      </c-table>
    </c-card>

    <c-card title="예약 상세 정보 입력" class="mt-12">
      <span class="red--text ml-0 pl-0 mb-5">*</span> 는 필수입력항목입니다.
      <v-row>
        <v-col cols="2">
          <span class="red--text">*</span> 일자 선택
        </v-col>
        <v-col cols="2">
          <v-menu nudge-bottom="30" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="input.deliveryInfo.date"
                prepend-icon="event"
                readonly dense
                v-on="on"
                tabindex="5"
              ></v-text-field>
            </template>
            <c-date-picker
              v-model="input.deliveryInfo.date"
              firstDayOfWeek="1"
              noTitle="true" scrollable="true"
              locale="ko-kr"
            >
            </c-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="7">
          <c-time-picker
            v-model="input.deliveryInfo.time"
            :minute-interval="5"
            :h-range="[0,24]"
            :autoScroll="true"
            :defaultAutoScrollValue="7"
            :readonly=false
            :tabindex="6"
          ></c-time-picker>
        </v-col>

        <v-col cols="2">
          <span class="red--text">*</span> 배송 물품
        </v-col>
        <v-col cols="10">
            <v-checkbox v-for="item in input.deliveryItems" :label="item.configName" :value="item" v-model="input.deliveryInfo.parcels"
                        hide-details dense class="d-inline-block mr-3 pt-0 mt-0" tabindex="7">
            </v-checkbox>

          <v-text-field v-model="input.deliveryInfo.description" :rules="[rules.counter]"
                        maxlength="30" counter style="max-width: 560px"
                        placeholder="배송 물품에 대한 설명을 입력해주세요.(30자 이내)"
                        tabindex="8">

          </v-text-field>
        </v-col>
      </v-row>
    </c-card>

    <c-card title="출발지 / 도착지 설정" class="mt-12">
      <search-delivery-location
          :delivery-date="input.deliveryInfo.date"
          :delivery-time="input.deliveryInfo.time"
          :delivery-fare="input.deliveryInfo.fare"
          @locationInfo="setLocationInfo"
          :customer-info="input.customerInfo"
          ref="searchDeliveryLocation"
      />
    </c-card>

    <v-row class="pt-4" justify="end" align="start">
      <v-tooltip left>
        <template #activator="{ on }">
          <v-icon class="mr-2" v-on="on" tabindex="16">mdi-information-outline</v-icon>
        </template>
        <div style="width:200px;">
          <span class="tooltip__custom-chip">배차대기</span> 는 담당 차량이 배정되지 않은 상태입니다. 배차 요청을 통해 담당차량을 배정할 수 있습니다.
        </div>
      </v-tooltip>
      <c-btn class="mr-3 " color="black" outlined @click="onReceiveDelivery('waiting')" style="background-color: white; opacity: 1;" tabindex="17">배차대기</c-btn>
      <c-btn class="mr-3 " color="blue" @click="onReceiveDelivery('reception')" tabindex="18">배송 접수</c-btn>
    </v-row>

    <customer-info-dialog
        :open.sync= "input.showCustomerInfoDialog"
        :customerInfo.sync = "input.customerDetailInfo"
        :groupInfo.sync = "input.groupInfo"
    ></customer-info-dialog>

  </v-container>
</template>

<script>
  import CustomerCUDialog from '../../Default/Customer/CustomerCUDialog';
  import SearchDeliveryLocation from "@/views/CallTaxi/Delivery/SearchDeliveryLocation";
  import CustomerInfoDialog from "@/views/CallTaxi/Reserve/CustomerInfoDialog";

  export default {
    components:{SearchDeliveryLocation, CustomerCUDialog, CustomerInfoDialog},
    data() {
      return {
        input:{
          customerSearchList:[],
          showCustomerList:false,
          deliveryItems: [],
          items: [],
          customerInfo: {},
          customerFormInfo: {},
          name:'',
          lastNumber:'',
          deliveryInfo: {
            date: '',
            time: '',
            parcels:[],
            description:'',
            fare: {
              type: '',
              detail: ''
            },
          },
          registerCustomerDialog:false,
          locationInfo:{},

          showCustomerInfoDialog : false,
          customerDetailInfo : [],
          groupInfo : [],
        },
        default:{
          deliveryInfo: {
            date: this.$func.curDateString(),
            time:this.$moment().add(30, 'minutes').format('HH:mm'),
          },
        },
        headers:[
          {text:'이름', value:'name', align:'center'},
          {text:'전화번호', value:'mobileNo', align:'center'},
          {text:'회원 유형', value:'customerType', align:'center'},
          {text:'비고', value:'etc', align:'center'},
          {text:'상세보기', value:'detail', align:'center'},
        ],
        rules:{
          counter: value => (value || '').length <= 30 || ''
        },
      }
    },
    async mounted() {
      await this.initData();
      await this.initParcels();
    },
    computed:{
      showCustomerType() {
        if(this.input.items[0].length < 1) {
          return;
        }
        const customerInfo = this.input.items[0];
        if(!customerInfo || customerInfo.customerType === null) {
          return '일반';
        }
        const customerType = customerInfo.customerType.configValue;
        const customerTypeName = customerInfo.customerType.configName;

        return customerType === 'ct_normal' || customerType === 'ct_guardian' ? customerTypeName : '교통약자 ('+ customerTypeName +')';
      },
      fieldCheck() {
        const customerInfo = !this.input.customerInfo.id ? false : true;
        const deliveryInfo = !this.input.deliveryInfo.date || !this.input.deliveryInfo.time | this.input.deliveryInfo.parcels.length < 1 ? false : true;
        const locationInfo = !this.input.locationInfo || !this.input.locationInfo.departurePoint || !this.input.locationInfo.destinationPoint ? false: true;
        return customerInfo && deliveryInfo && locationInfo;
      },
    },
    methods: {
      getEtcInfo(customerInfo) {
        if(!customerInfo) {
          return "";
        }

        //FIXME: 추후에 cutomer dto로 변경하세요.....
        const {customerType, expectedDeliveryDate, mobilityWeakInfo} = customerInfo;

        if (customerType && customerType.configValue === 'ct_pregnant' && expectedDeliveryDate) {
          return expectedDeliveryDate + " 출산예정";

        } else if (customerType && customerType.configValue === 'ct_mobility_week' && mobilityWeakInfo) {
          const {handicapInfo, wheelchair} = mobilityWeakInfo;
          let displayText = "";

          const handicapArr = JSON.parse(handicapInfo);
          displayText = handicapArr.map(handicap => {
            const {type, degree} = handicap;
            return type+'('+degree+')';
          }).join();

          if (wheelchair !== '없음') {
            displayText += '/' + wheelchair + "휠체어";
          }

          return displayText;
        }

        return "";
      },
      initData() {
        this.input = this.$func.initObjectData(this.input, this.default);
      },
      initParcels() {
        let index = 0;
        let newList = [];
        const parcelList = [...this.$store.state.config.parcel_type];
        for(let i in parcelList) {
          const item = parcelList[i];
          if(item.configValue === 'pt_etc') {
            index = i;
          } else {
            newList.push(item);
          }
        }
        newList.push(parcelList[index]);
        this.input.deliveryItems = newList;
      },
      initCustomerInfo() {
        this.input.name='';
        this.input.lastNumber='';
      },
      initCustomerFormInfo() {
        this.input.customerFormInfo = {};
      },
      showMobilityWeekInfo(customer) {
        const isMobilityWeek = customer.mobilityWeakInfo;
        if(isMobilityWeek) {
          return JSON.parse(customer.mobilityWeakInfo.handicapInfo);
        }
        return null

      },
      showWheelChairInfo(customer) {
        const isMobilityWeek = customer.mobilityWeakInfo;
        if(isMobilityWeek) {
          return isMobilityWeek.wheelchair;
        }
        return '';

      },
      async reqAddCustomer(data) {
        try {
          await this.$api.addCustomer(data);
          this.initCustomerFormInfo();
          this.input.registerCustomerDialog = false;

        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqAddCustomer'});
        }
      },
      async reqSearchCustomer() {
        try {
          const name = this.input.name;
          const lastNumber = this.input.lastNumber;

          if(!name && !lastNumber) {
            this.$store.commit('snackbar', {msg:'회원 이름 또는 전화번호 뒷자리를 입력해주세요.'});
            return;
          }

          const res = await this.$api.getCustomerInfoByNameOrLastNumber(name, lastNumber);
          if(res.data.length === 1) {
            this.initCustomerInfo();
            this.input.items = [...res.data];
            this.input.customerInfo = res.data[0];
          } else {
            this.input.showCustomerList=true;
            this.input.customerSearchList = [...res.data];
          }
        } catch(err) {
          this.$store.commit('snackbar', {err, where:'reqSearchCustomer'});
        }
      },
      onSelectCustomer(customer) {
        this.initCustomerInfo();
        this.input.showCustomerList = false;
        this.input.items = [customer];
        this.input.customerInfo = customer;
      },
      /**
       * @param type: 'reception' | 'waiting'
       */
      async onReceiveDelivery(type) {
        const isValid = await this.validateItems();

        if(isValid) {
          await this.reqReceiveDelivery(type);
        }
      },
      async validateItems() {
        // 필드가 비어있을 때
        if (!this.fieldCheck) {
          this.$store.commit('snackbar', {msg:'비어있는 필드가 있습니다.'});
          return false;
        }

        // 출발 일시가 올바르지 않은 경우 & 비어있는 경우
        if (!this.reservationTimeCheck()) {
          this.$store.commit('snackbar', {where: 'makeReqReservationData', msg: '출발 일시를 올바르게 입력해주세요.'});
          return false;
        }

        // 센터정보에서 예약 가능한 시간이 아닐 때
        const centerOperTimeInfo = await this.getCenterOperTimeInfo();
        if (!this.checkEnableDriveTime(centerOperTimeInfo)) {
          const weekdayString = this.$func.getWeekdayString(centerOperTimeInfo.dayWeek);
          this.$store.commit('alert', {
            open: true,
            title: '차량 운행 시간이 아닙니다.',
            msg: `${weekdayString} 차량 운행 시간은 ${centerOperTimeInfo.startDrive} ~ ${centerOperTimeInfo.endDrive} 입니다.`,
          });

          return false;
        }

        return true;
      },
      reservationTimeCheck() {
        let reserveTime = this.input.deliveryInfo.time.split(":");
        const hour = reserveTime[0];
        const minute = reserveTime[1];

        return (hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59);
      },
      async getCenterOperTimeInfo() {
        const res = await this.$api.getCenterOperTime(this.$store.state.centerInfo.centerId);
        const selectedWeekday = this.$func.stringToDate(this.input.deliveryInfo.date).weekday();

        const centerOperTimeInfo = res.data.find(centerOperTime => {
          if (!centerOperTime)
            return false;

          return (centerOperTime.dayWeek === selectedWeekday
              && centerOperTime.operation === 'Enable');
        })

        return centerOperTimeInfo;
      },
      checkEnableDriveTime(centerOperTimeInfo) {
        if (!centerOperTimeInfo) {
          return false;
        }

        const [hour, minute] = this.input.deliveryInfo.time.split(":");
        const [startDriveHour, startDriveMinute] = centerOperTimeInfo.startDrive.split(':');
        const [endDriveHour, endDriveMinute] = centerOperTimeInfo.endDrive.split(':');

        return (hour > startDriveHour || (hour === startDriveHour && minute >= startDriveMinute))
            && (hour < endDriveHour || (hour === endDriveHour && minute <= endDriveMinute));
      },
      setLocationInfo(location) {
        this.input.locationInfo = location;
      },
      /**
       * @param type: 'reception' | 'waiting'
       */
      async reqReceiveDelivery(type) {
        try {
          const startTime = this.$func.dateTimeToString(this.input.deliveryInfo.date + ' ' + this.input.deliveryInfo.time);
          let request = {
            'customerId' : this.input.customerInfo.id,
            'expectedDeparture': this.input.locationInfo.departure,
            'expectedDeparturePoint': this.input.locationInfo.departurePoint,
            'expectedDestination' : this.input.locationInfo.destination,
            'expectedDestinationPoint' : this.input.locationInfo.destinationPoint,
            'expectedStartTime' : startTime,
            'expectedEndTime' : this.$moment(startTime).add(this.input.locationInfo.driveTime*1000, 'ms').format('YYYY-MM-DD HH:mm:ss'),
            'expectedTotalDistance' : this.input.locationInfo.distance, // 미터
            'parcelType':JSON.stringify(this.input.deliveryInfo.parcels),
            'parcelDescription':this.input.deliveryInfo.description,
            'expectedFee' : this.input.locationInfo.deliveryFee,
            'deliveryRange':this.input.locationInfo.deliveryRange,
            'deliveryFareType': this.input.deliveryInfo.fare.type,
            'deliveryFareDetail': this.input.deliveryInfo.fare.detail,
            'departureDescription':this.input.locationInfo.departureComment,
            'destinationDescription':this.input.locationInfo.destinationComment
          }
          const res = await this.$api.createDelivery(request);

          if (type === 'reception') {
            this.$router.push(`/delivery/reception/done/${res.data}`);
          } else {
            this.$store.commit('snackbar', {
              color: 'blue',
              msg: '예약 정보가 배차대기 상태로 저장됩니다. 추후 배송 내역에서 배차를 진행해주세요.'
            });
            this.clearData();
          }

        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqReceiveDelivery'});
        }
      },
      showCustomerInfoDlg(item) {
        this.input.showCustomerInfoDialog = true;
        this.input.customerDetailInfo = item;
        this.reqGetJoinedGroupDetailList(item.id);
      },
      async reqGetJoinedGroupDetailList(customerId) {
        try {
          const res = await this.$api.getJoinedGroupDetailList(customerId);

          this.input.groupInfo = res.data.map(item => {
            item.groupName = item.groupInfo.name;
            item.type = item.groupInfo.type.configName;
            item.memberCnt = item.groupInfo.memberCnt;
            return item;
          });
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqGetJoinedGroupDetailList'});
        }
      },
      clearData() {
        this.initData();
        this.initParcels();
        this.$refs.searchDeliveryLocation.clearData();
      }
    }
  }
</script>

<style scoped>
.tooltip__custom-chip {
  background-color: #ed3843;
  color: #fff;
  border-radius: 15px;
  padding: 0 5px;
}
</style>
